// extracted by mini-css-extract-plugin
export default {"form":"GB1qcgjYH2GlLP2Imlxf","label":"TiQvEAuuzE6InsCGUrRk","textarea":"gHEM0k8h763wj0dEUv_q","error":"uAIsmdZaVEtTApdxK9DQ","actions":"_2ks62mHFmhJe6fGSSN_"};